var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mjkopc3ooa",
    d: "M0 0L23.4 0 23.4 23.4 0 23.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "swq8xqjx9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mjkopc3ooa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M11.703 0c-2.17 0-4.295.602-6.14 1.738C4.528 2.38 3.6 3.175 2.808 4.097.992 6.215-.004 8.91 0 11.697c-.003.734.068 1.466.208 2.187.074.4.172.793.292 1.182 1.04 3.462 3.627 6.252 7.006 7.556 2.701 1.037 5.693 1.037 8.393 0 3.38-1.304 5.962-4.094 6.995-7.556.125-.391.225-.79.298-1.194.14-.72.21-1.452.208-2.186C23.4 5.239 18.166.009 11.703 0m8.511 13.95c-.635 2.816-2.566 5.168-5.207 6.345-.63.271-1.361-.018-1.633-.646l-.02-.049c-.063-.183-.116-.37-.157-.56h-2.995c-.04.19-.093.377-.156.56-.17.487-.636.811-1.152.801-.175 0-.347-.036-.506-.106-2.64-1.179-4.57-3.53-5.208-6.345-.14-.597.198-1.203.781-1.4l.303-3.162c-.481-.071-.814-.518-.743-.999.01-.067.028-.132.052-.194.794-2.092 2.332-3.817 4.321-4.849 1.178-.604 2.484-.92 3.809-.919 3.643.057 6.872 2.352 8.118 5.768.179.451-.043.963-.496 1.14-.063.026-.128.043-.195.053l.304 3.162c.582.197.92.803.78 1.4",
    mask: "url(#swq8xqjx9b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M18.563 9.237c-2.087-1.2-4.457-1.826-6.866-1.81-2.41-.005-4.777.63-6.86 1.838l-.303 3.183c.169-.01.337-.01.505 0 1.411.003 2.761.574 3.742 1.587 1 1.021 1.557 2.395 1.551 3.822.001.212-.012.423-.04.634h2.81c-.025-.22-.035-.441-.028-.662-.035-2.95 2.334-5.372 5.292-5.409.166-.01.333-.01.5 0l-.303-3.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M13.632 11.7c0 1.064-.865 1.927-1.932 1.927-1.066 0-1.931-.863-1.931-1.927 0-1.065.865-1.927 1.931-1.927 1.067 0 1.932.862 1.932 1.927"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDriver);
export default __webpack_public_path__ + "static/media/homeDriver.0d6718b5fa36ace871adbbc58b6fc0c7.svg";
export { ForwardRef as ReactComponent };